import { CALCULATION_PATH } from "../../shared/routing/paths/app";
import { CfcLanding } from "./cfc-landing";

/**
 * CFC's own entry point for app-shell's `cfc` sidebar entry, since `/` is the hub. Deliberately
 * toggle-independent, so app-shell can repoint `cfc` without waiting on ConfigCat. No deep-link
 * restore: honouring a stored path here would send a Calculate click somewhere unrelated.
 */
export const CalculationRedirectRoute = {
  path: CALCULATION_PATH,
  element: <CfcLanding />,
};
